import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { ICommendaProduct } from './types';

interface ProductsResponse {
  data: ICommendaProduct[];
  nextCursor: string | null; // Make sure it can be null
  totalProducts: number;
}

interface UseSalesTaxProductsParams {
  token?: string;
  filters: {
    corporationId?: number;
    tax_codes?: string[];
  };
  cursor?: string | null;
  limit?: number;
  search_term?: string;
}

export function useSalesTaxProducts({
  token,
  filters,
  search_term,
  cursor = null,
  limit = 10,
}: UseSalesTaxProductsParams) {
  const query = new URLSearchParams();

  if (filters.corporationId) {
    query.append('corporationId', filters.corporationId.toString());
  }

  if (cursor) {
    query.append('cursor', cursor);
  }

  // ADD FILTERS
  if (filters.tax_codes) {
    let taxCodes = Array.isArray(filters.tax_codes)
      ? filters.tax_codes.join(',')
      : filters.tax_codes;
    query.append('tax_codes', taxCodes);
  }

  if (search_term) {
    query.append('search_term', search_term);
  }

  query.append('limit', limit.toString());

  const { data, error, isLoading, mutate } = useSWR<ProductsResponse>(
    `new-sales-tax/products?${query}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  return {
    data: data
      ? {
          products: data?.data,
          nextCursor: data.nextCursor,
          totalProducts: data.totalProducts,
        }
      : {
          products: [],
          nextCursor: null,
          totalProducts: 0,
        },
    mutate,
    error,
    isLoading,
  };
}
